import { AspectRatioKeeper, Image } from 'taboola-ultimate-ui';
import ThumbnailOverlay from 'modules/campaigns/modules/creative-creator/components/ThumbnailOverlay/ThumbnailOverlay';
import ThumbnailLoading from 'modules/campaigns/modules/creative-creator/components/ThumbnailsField/ThumbnailGallery/ThumbnailLoading/ThumbnailLoading';
import { modifyExternalUrl } from 'modules/campaigns/services/utils';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './uploadedImage.module.scss';

export const UploadedImage = ({ imageDataUrl, onCleanMedia }) => {
    return (
        <div className={styles['container']}>
            <div className={styles['upload-header']}>
                <FormattedMessage
                    id="creative.editor.tab.aiGenerated.imageToMotion.header.uploaded"
                    defaultMessage="Selected image"
                />
            </div>
            <div className={styles['upload-media-container']}>
                <AspectRatioKeeper>
                    <Image
                        src={modifyExternalUrl(imageDataUrl)}
                        alt="Card media"
                        loadingComponent={<ThumbnailLoading />}
                    />
                </AspectRatioKeeper>
                <ThumbnailOverlay onButtonClick={() => onCleanMedia()} isReloadButton={false} showXButton={true} />
            </div>
        </div>
    );
};
